import { useQuery } from '@tanstack/react-query';
import { loadShopifyCollectionProducts } from 'api/shopifyV2/products';
import { StoreCode } from 'api/shopifyV2/storeCode';
import { CollectionProduct } from 'api/shopifyV2/types';

interface GetProductsOptions {
  storeCode: StoreCode;
  collectionHandle: string;
  enabled?: boolean;
  identifiers?: { key: string; namespace: string }[];
}

export function useQueryGetShopifyCollectionProducts({
  storeCode,
  collectionHandle,
  identifiers,
  enabled
}: GetProductsOptions) {
  return useQuery<CollectionProduct[], Error>({
    queryKey: ['shopifyCollectionProducts', storeCode, collectionHandle, identifiers],
    queryFn: () => loadShopifyCollectionProducts(storeCode, collectionHandle, identifiers),
    enabled
  });
}
